import React, { useLayoutEffect, useState, useEffect } from 'react'
import DataGrid, {
    Column,
    Export,
    HeaderFilter,
    Pager,
    Paging,
    SearchPanel,
} from "devextreme-react/data-grid";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
import { SelectBox, TextBox, CheckBox, TextArea } from "devextreme-react";
import Modal from "react-modal";
import { useNavigate, useLocation } from "react-router-dom";
import { ApplicationService } from '../../../apis/apiServices/Application';
import { ModuleService } from '../../../apis/apiServices/Module';
import { FeatureService } from '../../../apis/apiServices/Feature';
import { FormFieldService } from '../../../apis/apiServices/FormField'
import { WorkFlowCategoryService } from '../../../apis/apiServices/WorkFlowCategory';

import { Icon } from "@iconify/react";

export default function WorkFlowCategoryComponent(props) {

    const navigate = useNavigate();
    const user = useSelector((state) => state.user.data);
    const [FormTypeList, setFormTypeList] = useState(null);
    const [typeByField, setTypeByField] = useState(null);
    const [isFormTypeModalOpen, setIsFormTypeModalOpen] = useState(false);
    const [isTypeModalOpen, setIsTypeModalOpen] = useState(false);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const [errors, setErrors] = useState({});
    const [formType, setFormType] = useState({
        typeName: '',
        applicationId: 3,
        fieldId: 0,
        featureId: 0,
        moduleId: 0,
        description: '',
        isActive: true,
    });

    const [dropdownData, setDropdownData] = useState({
        applicationList: [{ id: 3, name: "AssetZ" }],
        moduleList: [],
        featureList: [],
        formList: [],
        fieldList: [],
    });

    const fetchAllData = async () => {
        const [
            categoryListResponse,
        ] = await Promise.all([
            WorkFlowCategoryService?.getWorkFlowCategoryList({}),
        ])

        setFormTypeList((categoryListResponse?.isSuccess) ? categoryListResponse?.data : []);
    };

    const fetchModuleData = async (applicationId) => {
        let request = {
            applicationId: applicationId,
        };
        let moduleResponse = await ModuleService.getModuleDropdown(request);
        setDropdownData(prevState => {
            return {
                ...prevState,
                moduleList: moduleResponse || [],
            }
        });
    };

    const fetchFeatureData = async (moduleId) => {
        let request = {
            moduleId: moduleId,
        };
        let featureResponse = await FeatureService?.GetFeatureDropdown(request);

        setDropdownData(prevState => {
            return {
                ...prevState,
                featureList: (featureResponse?.isSuccess && featureResponse?.data) ? featureResponse?.data : [],
            }
        });
    };
    const fetchFieldData = async (formId) => {
        let request = {
            featureId: formId,
        };
        let fieldResponse = await FormFieldService?.getFormFieldDropdown(request);

        setDropdownData(prevState => {
            return {
                ...prevState,
                fieldList: (fieldResponse?.isSuccess && fieldResponse?.data) ? fieldResponse?.data : [],
            }
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitted(true);

        const newErrors = {};
        if (!formType?.applicationId) newErrors.applicationId = "Please select application.";
        if (!formType?.moduleId) newErrors.moduleId = "Please select module.";
        if (!formType?.featureId) newErrors.featureId = "Please select form.";
        // if (!formType?.fieldId) newErrors.fieldId = "Please select field.";
        if (!formType?.typeName) newErrors.typeName = "Please enter name.";
        // if (!formType?.description) newErrors.description = "Please enter description.";

        if (Object.keys(newErrors).length > 0) {
            setErrors(newErrors);
            setIsSubmitted(false);
            return;
        }

        let body = {
            id: formType?.formTypeId || 0,
            code: formType?.typeCode || "",
            name: formType?.typeName || "",
            description: formType?.typeName || "",
            isActive: formType?.isActive || false,
            formId: formType?.featureId || 0,
            ModifiedBy: user.userId,
        }

        const response = await WorkFlowCategoryService.createUpdateWorkFlowCategory(body);

        if (!response?.isSuccess) {
            Swal.fire("", `${response?.message || "opps! something went wrong while setting up request"}`, "error");
            setIsSubmitted(false);
            return;
        }
        Swal.fire(
            "",
            response?.message,
            "success"
        ).then(() => {
            setIsSubmitted(false);
            navigate("/WorkFlowCategory")
        });
    };

    const openModal = () => {
        setIsFormTypeModalOpen(true);
        setFormType(prevState => {
            return {
                ...prevState,
                FormTypeName: '',
                description: '',
                isActive: true,
                featureId: 0,
                moduleId: 0,
            }
        });
    };

    const closeModal = () => {
        setIsFormTypeModalOpen(false);
        setIsSubmitted(false);
        setErrors({});
    };

    const handleInputChange = (key, value) => {
        setFormType(prevState => {
            return {
                ...prevState,
                [key]: value
            }
        })
    };


    const renderStatusCell = (rowData) => {
        const isActive = rowData?.data?.isActive === true;

        return (
            <div
                style={{ color: isActive ? '#12b300' : '#e33131', }}
            >
                <span />
                {isActive ? 'Active' : 'Inactive'}
            </div>
        );
    };

    const openEdit = (data) => {
        setIsFormTypeModalOpen(true);
        setFormType({
            FormTypeId: data?.FormTypeId || "",
            isActive: data?.isActive || false,
            id: data?.id,
            fieldId: data?.formFieldId,
            FormTypeName: data?.name,
            applicationId: data?.applicationId,
            moduleId: data?.moduleId,
            featureId: data?.featureId,
        });
    }

    const viewFormTypeFeatures = async (e) => {

    }
    const closeTypeModal = () => {
        setIsTypeModalOpen(false);
    };


    useLayoutEffect(() => {
        document.querySelector("#pageTitle").innerHTML = "WorkFlow Category";
    }, []);
    useEffect(() => {
        fetchAllData();
    }, []);

    return (<>
        <div className="content">
            <div className="card">
                <div className="card-body">
                    <div className="row">
                        <div className="col-12">
                            <DataGrid
                                dataSource={FormTypeList}
                                columnAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                allowColumnResizing={false}
                                onToolbarPreparing={(e) => {
                                    e.toolbarOptions.items.unshift({
                                        location: "before",
                                        widget: "dxButton",
                                        visible: props?.isAllowedForThisRole || props?.featurePermission?.canAdd || false,
                                        options: {
                                            icon: "plus",
                                            text: "Add",
                                            hint: "Add",
                                            type: "default",
                                            stylingMode: "contained",
                                            onClick: () => openModal(),

                                        }
                                    });
                                }}
                            >
                                <Column dataField="formName" caption="Form" />
                                <Column dataField="formFieldName" caption="Field Name" width />
                                <Column dataField="categoryName" caption="Category Name" />

                                <HeaderFilter visible={false} />
                                <SearchPanel
                                    visible={true}
                                    highlightCaseSensitive={true}
                                    width={240}
                                    placeholder="Search..."
                                />
                                <Paging defaultPageSize={15} />
                                <Pager
                                    visible={true}
                                    allowedPageSizes={[10, 15, 20, 50, 100]}
                                    showPageSizeSelector={true}
                                    showInfo={true}
                                    showNavigationButtons={true}
                                />
                                <Export
                                    enabled={props?.isAllowedForThisRole || props?.featurePermission?.canExport || false}
                                    fileName="Form Type"
                                />
                            </DataGrid>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Modal
            ariaHideApp={false}
            isOpen={isFormTypeModalOpen}
            className="react-modal custom-modal-medium"
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={false}
            contentLabel="formType Modal"
        >
            <form onSubmit={handleSubmit} style={isSubmitted ? { pointerEvents: "none", opacity: 0.4 } : {}}>
                <div className="modal-header">
                    <h6 className="modal-title">{formType?.id ? "Update Category" : "Add Category"}</h6>
                </div>

                <div className="modal-body">
                    <div className="row">
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <div className='form-group'>
                                <label>
                                    Application <span className="text-danger">*</span>
                                </label>
                                <SelectBox
                                    dataSource={dropdownData?.applicationList || []}
                                    value={formType?.applicationId || null}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    placeholder="Select application"
                                    searchEnabled
                                    disabled={true}
                                    showClearButton={true}
                                    onSelectionChanged={(e) => {
                                        handleInputChange('applicationId', e?.selectedItem?.id);
                                        handleInputChange('applicationName', e?.selectedItem?.name);
                                        fetchModuleData(e?.selectedItem?.id);
                                    }}
                                />
                                {errors?.applicationId && <span className="error invalid-feedback">{errors?.applicationId}</span>}
                            </div>
                        </div>
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <div className='form-group'>
                                <label>
                                    Module <span className="text-danger">*</span>
                                </label>
                                <SelectBox
                                    dataSource={dropdownData?.moduleList}
                                    value={formType?.moduleId}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    defaultValue=""
                                    placeholder="Select module"
                                    searchEnabled
                                    showClearButton={true}
                                    onSelectionChanged={(e) => {
                                        handleInputChange('moduleId', e?.selectedItem?.id);
                                        handleInputChange('moduleName', e?.selectedItem?.name);
                                        fetchFeatureData(e?.selectedItem?.id);
                                    }}
                                />
                                {errors?.moduleId && <span className="error invalid-feedback">{errors?.moduleId}</span>}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {/* Feature Filter */}
                        <div className='col-lg-6 col-md-6 col-sm-12'>
                            <div className='form-group'>
                                <label>
                                    Form <span className="text-danger">*</span>
                                </label>
                                <SelectBox
                                    dataSource={dropdownData?.featureList}
                                    value={formType?.featureId}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    defaultValue=""
                                    placeholder="Select form"
                                    searchEnabled
                                    showClearButton={true}
                                    onSelectionChanged={(e) => {
                                        handleInputChange('featureId', e?.selectedItem?.id);
                                        handleInputChange('featureName', e?.selectedItem?.name);
                                        fetchFieldData(e?.selectedItem?.id);
                                        //fetchFormCategoryData(e?.selectedItem?.id);
                                    }}
                                />
                                {errors?.featureId && <span className="error invalid-feedback">{errors?.featureId}</span>}
                            </div>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12 d-none">
                            <div className="form-group">
                                <label>
                                    Field <span className="text-danger">*</span>
                                </label>
                                <SelectBox
                                    dataSource={dropdownData?.fieldList}
                                    value={formType?.fieldId}
                                    valueExpr="id"
                                    displayExpr="name"
                                    className="form-control"
                                    defaultValue=""
                                    placeholder="Select field"
                                    searchEnabled
                                    showClearButton={true}
                                    onSelectionChanged={(e) => {
                                        handleInputChange('fieldId', e?.selectedItem?.id);
                                        handleInputChange('fieldName', e?.selectedItem?.name);
                                    }}
                                />
                                {errors.fieldId && (
                                    <div className="text-danger invalid-feedback">{errors.fieldId}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="form-group">
                                <label>Name <span className="text-danger">*</span></label>
                                <TextBox
                                    className={`form-control ${errors.fieldName ? 'is-invalid' : ''}`}
                                    placeholder="Enter name"
                                    showClearButton={true}
                                    valueChangeEvent="keyup"
                                    value={formType?.typeName}
                                    onValueChanged={(e) => handleInputChange("typeName", e?.value)}
                                    maxLength={50}
                                />
                                {errors.typeName && (
                                    <div className="text-danger invalid-feedback">{errors.typeName}</div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="form-group d-flex align-items-center" style={{ gap: "10px", marginTop: "10px" }}>
                                <CheckBox
                                    value={formType?.isActive || false}
                                    onValueChanged={(e) =>
                                        setFormType(prev => ({ ...prev, isActive: e.value }))
                                    }
                                />
                                <label style={{ margin: 0 }}>Is Active</label>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={closeModal}
                        title="Cancel"
                    >
                        <i className="fas fa-times"></i> Cancel
                    </button>
                    <button type="submit" className="btn btn-primary btn-sm">
                        {isSubmitted ? (
                            <span title="In process"><i className="fas fa-spinner fa-spin"></i> In process</span>
                        ) : (
                            <span title="Submit"><i className="fas fa-check"></i> {formType?.id ? "Update" : "Submit"}</span>
                        )}
                    </button>
                </div>
            </form>
        </Modal>
        <Modal
            ariaHideApp={false}
            isOpen={isTypeModalOpen}
            className="react-modal custom-modal-large"
            onRequestClose={closeModal}
            shouldCloseOnOverlayClick={false}
            contentLabel="Feature Modal"
        >
            <form>
                <div className="modal-header">
                    {/* <h6 className="modal-title">{"Types - " {typeByField.name}}</h6> */}
                    <h6 className="modal-title">{"Types"}</h6>
                </div>
                <div className="modal-body">
                    <div className='row'>
                        <div className='col-12'>
                            <DataGrid
                                dataSource={typeByField}
                                columnsAutoWidth={true}
                                showColumnLines={false}
                                showRowLines={true}
                                showBorders={true}
                                allowColumnResizing={false}
                            >
                                <Column dataField="formTypeName" caption="Type Name" />
                                {/* <Column dataField="moduleDescription" caption="Description" width={300} /> */}
                                <Column
                                    dataField="formTypeDescription"
                                    caption="Description"
                                    allowFiltering={false}
                                    cellRender={(cellData) => (
                                        <div style={{ whiteSpace: "normal", wordWrap: "break-word" }}>
                                            {cellData.value}
                                        </div>
                                    )}
                                />
                                {/* <Column dataField="isActive" caption="Status" alignment="left"
                                    cellRender={(rowData) => renderStatusCell(rowData)}
                                    calculateCellValue={(rowData) => rowData.isModuleActive ? "Active" : "Inactive"}
                                /> */}
                                <HeaderFilter visible={false} />
                                <SearchPanel visible={true} highlightCaseSensitive={true} width={240} placeholder="Search..." />
                                <Paging defaultPageSize={5} />
                                <Pager showPageSizeSelector={true} allowedPageSizes={[5]} showInfo={true} visible={true} />
                            </DataGrid>
                        </div>
                    </div>

                </div>
                <div className="modal-footer">
                    <button
                        type="button"
                        className="btn btn-outline-primary btn-sm"
                        onClick={closeTypeModal}
                        title="Close"
                    >
                        <i className="fas fa-times"></i> Close
                    </button>
                </div>
            </form>
        </Modal>
    </>
    )
}


